<template>
  <!-- <div> -->
  <vs-card>
    <div class="worker">
      <div class="title">
        <vs-icon icon="work"></vs-icon>
        <h3>Today, New item in Stock</h3>
      </div>
      <br />
      <p>Item : {{ $store.getters['unicorn/newStockToday'] }}</p>
    </div>
  </vs-card>
  <!-- </div> -->
</template>

<script>
export default {
  props: {
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
.worker {
  // background-color: aqua;
  // width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  .title {
    display: flex;
    gap: 10px;
  }
  p {
    margin: 0;
  }
}
</style>